<router-outlet></router-outlet>
<div class="sk-container" [ngClass]="{ 'sk-loading': state.loading }">
    <loading-screen [displayed]="state.loading" [templateType]="'GENERIC'"></loading-screen>
</div>
